import ButtonContainer from "@components/ButtonContainer";
import TextEditorTwo from "@components/EasyDev/text-editor/TextEditor";
import FileUpload from "@components/Shared/FileUpload";
import FormDatePickerField from "@components/Shared/FormDatePickerField";
import FormTextareaField from "@components/Shared/FormTextareaField";
import FormTextField from "@components/Shared/FormTextField";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement } from "react";
import { Field } from "react-final-form";

const CreateForm = ({ handleSubmit }: IFormProps): ReactElement => (
  <form className="form form--horizontal" onSubmit={handleSubmit}>
    <div className="form__form-group">
      <span className="form__form-group-label">Title</span>
      <div className="form__form-group-field">
        <Field
          name="title"
          component={FormTextField}
          type="text"
          placeholder={"Enter a Title"}
          isAboveError
          minLength="4"
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Date</span>
      <div className="form__form-group-field">
        <Field
          name="date"
          component={FormDatePickerField}
          placeholder="Enter a Date"
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Summary</span>
      <div className="form__form-group-field">
        <Field
          name="summary"
          component={FormTextareaField}
          type="text"
          placeholder={"Enter a Summary"}
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Body</span>
      <div className="form__form-group-field">
        <Field name="body" component={TextEditorTwo} isAboveError />
      </div>
    </div>

    <FileUpload title="Image" isSingle formFieldName="imageUrl" />

    <ButtonContainer />
  </form>
);

export default CreateForm;
